import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";

import { changeItemAmount, deleteItemFromCart } from "../redux/winesSlice";
import "./CartWineItem.css";

function CartWineItem({ itemId }) {
  const dispatch = useDispatch();
  const itemsInCart = useSelector((state) => state.wines.cart);

  // ✅ Find exact cart item (size-specific)
  const cartItem = itemsInCart.find((v) => v.item.id === itemId);
  if (!cartItem) return null;

  // ✅ Product snapshot from cart
  const product = cartItem.item;
  const selectedSize = product.selectedSize || "";
   const totalStock = Number(product.selectedStock || 0);
const remainingStock = totalStock - cartItem.amount;
  const totalPrice =
    cartItem.amount * Number(product.selectedRate || 0);

  function increaseAmount() {
  if (cartItem.amount < totalStock) {
    dispatch(
      changeItemAmount({
        currentItemId: product.id,
        currentAmount: cartItem.amount + 1,
      })
    );
  }
}

  function decreaseAmount() {
    const newAmount = cartItem.amount - 1;
    if (newAmount > 0) {
      dispatch(
        changeItemAmount({
          currentItemId: product.id,
          currentAmount: newAmount,
        })
      );
    } else {
      dispatch(deleteItemFromCart(product.id));
    }
  }

  return (
    <div className="cart-item-block">
      <div className="cart-item-img-block">
        <img
          className="cart-item-img"
          src={`https://gitstool.in/liquor/shop_app/${product.thumb}`}
          alt={product.brand_nm}
          title={product.brand_nm}
        />
        <p className="cart-item-name">{product.cat_name}</p>
        <p className="cart-item-name1">{selectedSize}</p>
         <p className="cart-item-title">{product.brand_nm}</p>
           
      </div>

      <div className="cart-item-wrap">
        <div className="cart-item-info-block">
          <div className="cart-item-par-row">
            <div className="cart-item-par">
            <span className="product-group-cart">{product.group}</span>-{product.shop}</div>
         <p className="cart-item-par">{product.shopAdd}</p>
         
         
         
         </div>
        </div>

        <div className="cart-item-btns-wrap">
          <div className="cart-item-count-block">
            <div className="stcock-btn"><p className="stock">
  {remainingStock > 0 ? `${remainingStock}` : "0"}
</p></div>
            <input
              type="button"
              value="-"
              className="cart-item-count-btn"
              onClick={decreaseAmount}
            />
            <span className="cart-item-count-text">
              {cartItem.amount}
            </span>
            <input
              type="button"
              value="+"
              className="cart-item-count-btn"
              onClick={increaseAmount}
            />
          </div>

          <div className="cart-item-price-block">
            ₹{totalPrice}
          </div>

          <div className="cart-item-del-block">
            <input
              type="button"
              value=""
              className="cart-item-del-btn"
              onClick={() =>
                dispatch(deleteItemFromCart(product.id))
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}

CartWineItem.propTypes = {
  itemId: PropTypes.string.isRequired,
};

export default CartWineItem;
